import { privateFetch } from "api/privateFetch";

/**
 * Get timezones
 * @returns {Promise<{timeZoneId: number;timeZoneName: string;}[]>} Timezones
 */
const getTimeZones = async () => {
  const { data } = await privateFetch.get("timezones");
  return data;
};

export default getTimeZones;
